module.exports = __webpack_public_path__ + "img/6.3697b3aa.png";